var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { cameraColor } from './constants';
export default styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  background-color: ", ";\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 9px;\n  right: 10%;\n"], ["\n  border-radius: 50%;\n  background-color: ",
    ";\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 9px;\n  right: 10%;\n"])), function (props) {
    return props.color ? props.color : cameraColor;
});
var templateObject_1;
//# sourceMappingURL=Camera.js.map